import type { TypedDocumentNode } from '@base-app/web2'
import { gql } from '@base-app/web2'
import type { Radio } from './types'

export const CREATE_RADIO: TypedDocumentNode<
  { createRadio: Radio },
  {
    client_id: string
    application_id: string
    name: string
    stream_url?: string | null
    listening_url?: string | null
    observations?: string | null
    unavailable_message?: string | null
    old_id?: string | null
  }
> = gql`
  mutation CreateRadio($client_id: ID!, $application_id: ID!, $name: String!, $stream_url: String, $listening_url: String, $observations: String, $unavailable_message: String, $old_id: String) {
    createRadio(client_id: $client_id, application_id: $application_id, name: $name, stream_url: $stream_url, listening_url: $listening_url, observations: $observations, unavailable_message: $unavailable_message, old_id: $old_id) {
      id client_id application_id name stream_url listening_url observations unavailable_message old_id created_at updated_at
    }
  }
`

export const UPDATE_RADIO: TypedDocumentNode<
  { updateRadio: Radio },
  {
    id: string
    name?: string
    stream_url?: string | null
    listening_url?: string | null
    observations?: string | null
    unavailable_message?: string | null
    old_id?: string | null
  }
> = gql`
  mutation UpdateRadio($id: ID!, $name: String, $stream_url: String, $listening_url: String, $observations: String, $unavailable_message: String, $old_id: String) {
    updateRadio(id: $id, name: $name, stream_url: $stream_url, listening_url: $listening_url, observations: $observations, unavailable_message: $unavailable_message, old_id: $old_id) {
      id client_id application_id name stream_url listening_url observations unavailable_message old_id created_at updated_at
    }
  }
`

export const DELETE_RADIO: TypedDocumentNode<{ deleteRadio: boolean }, { id: string }> = gql`
  mutation DeleteRadio($id: ID!) {
    deleteRadio(id: $id)
  }
`
